export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/DJ-06f6355755a15a380f5f4788ef4b6468.png";